
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import worskpaceFederationDatasetDialogDescriptor from './WorskpaceFederationDatasetDialogDescriptor.json'

export default defineComponent({
    name: 'workspace-federation-dataset-dialog',
    components: { Dialog },
    emits: ['close'],
    props: { visible: { type: Boolean }, dataset: { type: Object } },
    data() {
        return {
            worskpaceFederationDatasetDialogDescriptor
        }
    }
})
